export const ADD_LANE = 'ADD_LANE';
export const DELETE_LANE = 'DELETE_LANE';
export const EDIT_LANE = 'EDIT_LANE';
export const LOAD_LANE = 'LOAD_LANE';


export function addLane(data) {
  return {
    type: ADD_LANE,
    payload: data,
  }
}

export function deleteLane(data) {
  return {
    type: DELETE_LANE,
    payload: data,
  }
}

export function editLane(data) {
  return {
    type: EDIT_LANE,
    payload: data,
  }
}

export function loadLane(data) {
  return {
    type: LOAD_LANE,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/boardLane/index.js